
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4a1 1 0 011-1h.697a1 1 0 01.555.168l2.249 1.5a.4.4 0 010 .665l-2.056 1.37A1 1 0 007 7.535v.795C8.47 8.12 10.18 8 12 8c1.82 0 3.53.12 5 .33V4a1 1 0 011-1h.697a1 1 0 01.555.168l2.249 1.5a.4.4 0 010 .665l-2.056 1.37a1 1 0 00-.445.832V8.71c1.85.46 3 1.09 3 1.79 0 1.38-4.5 2.5-10 2.5S2 11.88 2 10.5c0-.7 1.15-1.33 3-1.79V4zm7 5.5c-3.31 0-5 .17-5 1s1.69 1 5 1 5-.17 5-1-1.69-1-5-1zm0 5.25c3.423 0 6.506-.54 8.693-1.397.302-.118.63.136.573.455l-1.12 6.365a1 1 0 01-.985.827H16a1 1 0 01-1-1v-1a2 2 0 00-2-2h-2a2 2 0 00-2 2v1a1 1 0 01-1 1H4.84a1 1 0 01-.986-.827l-1.12-6.365c-.057-.319.271-.573.573-.455 2.187.856 5.27 1.397 8.693 1.397z","fill":"#fff"}})])
          )
        }
      }
    